module.exports = __webpack_public_path__ + "img/Frame 1087two.92eee1d8.png";